import React from 'react';

import { FormBuilder, EMPTY_OBJECT } from 'commons-ui';
import { validationSchema, FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './utils/formConfig';
import type { PayoutDetailsFormProps } from '../../../models/payoutDetails.model';

const DownloadPayoutDetails: React.FC<PayoutDetailsFormProps> = ({ onCancel, onSubmit, loading, submitLabel = 'Download' }) => {
	const handleFormSubmit = (formData: { ticketId: string; description: string }) => {
		onSubmit(formData.ticketId, formData.description);
	};

	const setShowLoader = () => {};

	return (
		<FormBuilder
			data={EMPTY_OBJECT}
			mode='create'
			showLoader={loading}
			setShowLoader={setShowLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={onCancel}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			validationSchema={validationSchema}
			buttonLabels={{
				submitLabel,
				discardLabel: 'Cancel'
			}}
			hidePopUp
		/>
	);
};

export default DownloadPayoutDetails;
